import { Role } from "./Role";

export interface RoleList {
  roles: Role[];
}

export const RoleListInitial: RoleList = {
  roles: [],
};